var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.14407,30.30411c-1.04549,0-2.00784,.33702-2.80029,.89819L9.63264,20.77495c.04216-.25691,.07921-.51604,.07921-.78486,0-.27459-.03697-.53949-.08091-.80165L26.17647,8.67683c.81935,.62974,1.83312,1.01906,2.947,1.01906,2.68189,0,4.85593-2.17054,4.85593-4.84795S31.80536,0,29.12348,0s-4.85593,2.17047-4.85593,4.84795c0,.23553,.0369,.46108,.06943,.68766L7.71987,16.09278c-.8046-.59053-1.78881-.95064-2.86394-.95064C2.17404,15.14214,0,17.31261,0,19.99009s2.17404,4.84795,4.85593,4.84795c1.08068,0,2.06912-.36439,2.87587-.96048l16.64593,10.38666c-.05365,.28857-.08958,.58373-.08958,.88783,0,2.67741,2.17404,4.84795,4.85593,4.84795s4.85593-2.17054,4.85593-4.84795-2.17411-4.84795-4.85593-4.84795Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.04cd8079278c3426346e48c734f016ff.svg";
export { ForwardRef as ReactComponent };